import React, { PureComponent } from 'react'
import {
  Modal,
  Spin,
  Tag,
  Button,
  Input,
  InputNumber,
  Select,
  Form,
  Descriptions,
  Icon,
  Popconfirm,
  notification,
} from 'antd'
import moment from 'moment'
import Request, { API_URL } from '../../../request'
import MediaViewer from '../../../components/MediaViewer'
import styles from './styles.less'

const { TextArea } = Input
const { Option } = Select

const STOCK_LANE = 'move_to_stock'

const STATUS_COLORS = {
  Completed: '#52c41a',
  Rejected: '#f5222d',
  Pending: '#fa8c16',
}

// the internal "Completed" review state is shown as "Approved"
const statusLabel = (s) => (s === 'Completed' ? 'Approved' : s)

const parseMedia = (data) => {
  if (!data) return { photos: [], videos: [] }
  if (Array.isArray(data)) {
    const photos = []
    const videos = []
    data.forEach((m) => {
      const type = (m && m.type) || ''
      if (type === 'video') videos.push(m)
      else photos.push(m)
    })
    return { photos, videos }
  }
  return {
    photos: data.photos || data.images || [],
    videos: data.videos || [],
  }
}

const fullUrl = (u) => {
  if (!u) return ''
  if (u.indexOf('http') === 0) return u
  return API_URL + (u.charAt(0) === '/' ? '' : '/') + u
}


const emptyStockModal = {
  visible: false,
  mediaId: null,
  productId: undefined,
  productName: '',
  quantity: undefined,
  unit: '',
  saving: false,
  itemOrderId: '',
  itemUser: '',
  itemSubCategory: '',
  itemType: '',
  description: '',
  remarks: '',
}

// Card rendered inside each lane — carries review (Complete/Reject) actions so
// the board doubles as the review surface (review and board are unified here).
const MediaCard = (cardProps) => {
  const item = cardProps.metadata || {}
  const url = fullUrl(item.url)
  const isVideo = item.type === 'video'
  const status = item.status || 'Pending'
  const {
    onPreview,
    onMoveToStock,
    onComplete,
    onReject,
    isRejecting,
    rejectText,
    onRejectText,
    onConfirmReject,
    onCancelReject,
    onDelete,
  } = item
  return (
    <div className={styles.boardCard} style={{ cursor: 'default' }}>
      <div
        className={styles.boardCardMedia}
        title="Click to preview"
        style={{ height: 84 }}
        onClick={(e) => {
          e.stopPropagation()
          if (onPreview) onPreview()
        }}
      >
        {isVideo ? (
          <video src={url} muted preload="metadata" draggable={false} />
        ) : (
          <img src={url} alt="" loading="lazy" draggable={false} />
        )}
        <span
          className={styles.boardCardStatus}
          style={{ background: STATUS_COLORS[status] }}
        >
          {statusLabel(status)}
        </span>
        {onPreview && (
          <button
            type="button"
            className={styles.boardCardPreviewBtn}
            title="Preview"
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => {
              e.stopPropagation()
              onPreview()
            }}
          >
            <Icon type="eye" />
          </button>
        )}
        {onDelete && (
          <span
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => e.stopPropagation()}
          >
            <Popconfirm
              title="Delete this media?"
              okText="Delete"
              cancelText="Cancel"
              onConfirm={() => onDelete()}
            >
              <button
                type="button"
                className={styles.boardCardHistoryBtn}
                title="Delete"
              >
                <Icon type="delete" />
              </button>
            </Popconfirm>
          </span>
        )}
      </div>
      <div className={styles.boardCardMeta}>
        {status === 'Pending' && (
          isRejecting ? (
            <div style={{ marginBottom: 8 }} onClick={(e) => e.stopPropagation()}>
              <Input
                size="small"
                autoFocus
                placeholder="Rejection reason..."
                value={rejectText}
                onChange={(e) => onRejectText && onRejectText(e.target.value)}
                onPressEnter={() => onConfirmReject && onConfirmReject()}
                style={{ marginBottom: 6 }}
              />
              <div style={{ display: 'flex', gap: 6 }}>
                <Button
                  size="small"
                  type="danger"
                  style={{ flex: 1 }}
                  onClick={() => onConfirmReject && onConfirmReject()}
                >
                  Confirm
                </Button>
                <Button
                  size="small"
                  style={{ flex: 1 }}
                  onClick={() => onCancelReject && onCancelReject()}
                >
                  Cancel
                </Button>
              </div>
            </div>
          ) : (
            <div className={styles.boardCardActions} style={{ marginBottom: 8 }}>
              <Button
                size="small"
                type="primary"
                icon="check"
                style={{ background: '#52c41a', borderColor: '#52c41a', color: '#fff' }}
                onClick={(e) => {
                  e.stopPropagation()
                  if (onComplete) onComplete()
                }}
              >
                Approve
              </Button>
              <Button
                size="small"
                type="danger"
                icon="close"
                onClick={(e) => {
                  e.stopPropagation()
                  if (onReject) onReject()
                }}
              >
                Reject
              </Button>
            </div>
          )
        )}
        {status === 'Rejected' && (
          <div className={styles.boardCardActions} style={{ marginBottom: 8 }}>
            <Button
              size="small"
              type="primary"
              icon="check"
              style={{ background: '#52c41a', borderColor: '#52c41a', color: '#fff' }}
              onClick={(e) => {
                e.stopPropagation()
                if (onComplete) onComplete()
              }}
            >
              Approve
            </Button>
          </div>
        )}

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
          {item.orderId ? <Tag style={{ margin: 0 }}>Order #{item.orderId}</Tag> : null}
          {item.userName ? <Tag style={{ margin: 0 }}>{item.userName}</Tag> : null}
          {item.subCategory ? <Tag style={{ margin: 0 }}>{item.subCategory}</Tag> : null}
        </div>
      </div>
      {onMoveToStock ? (
        <div className={styles.boardCardActions}>
          <Button
            size="small"
            type="primary"
            ghost
            icon="plus"
            onClick={(e) => {
              e.stopPropagation()
              onMoveToStock()
            }}
          >
            Move To Stock
          </Button>
        </div>
      ) : null}
    </div>
  )
}

class BoardModal2 extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      items: [],
      // production order form details (shown in the image preview)
      orderForm: null,
      // per-card reject-reason input
      rejectingId: null,
      rejectText: '',
      // move-to-stock popup + product master
      products: [],
      stockModal: { ...emptyStockModal },
      // media preview (gallery index into items)
      previewIndex: -1,
    }
    this.dirty = false
  }

  componentDidMount() {
    this.fetchProducts()
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible && this.props.group) {
      this.dirty = false
      this.setState({
        stockModal: { ...emptyStockModal },
        previewIndex: -1,
        orderForm: null,
      })
      this.fetchMedia()
      this.fetchOrderForm()
    }
  }

  // load the matching Production Order form record (shown in image preview)
  fetchOrderForm = () => {
    const { group } = this.props
    const orderId = group && (group.orderId || group.key)
    if (!orderId || orderId === 'unassigned') {
      this.setState({ orderForm: null })
      return
    }
    const idNum = Number(orderId)
    const query = Number.isNaN(idNum)
      ? { productionOrderId: orderId, results: 1 }
      : { productionOrderId: idNum, results: 1 }
    Request.productionOrderFormList(query).then(({ error, data }) => {
      this.setState({
        orderForm: !error && data && data.length ? data[0] : null,
      })
    })
  }

  // details table of the production order form, shown beside the image preview
  renderOrderDetailsPanel = () => {
    const o = this.state.orderForm
    if (!o) return null
    const fmt = (d) => (d ? moment(d).format('DD-MM-YYYY') : '-')
    return (
      <div>
        <div style={{ fontWeight: 600, fontSize: 14, marginBottom: 10 }}>
          Production Order Details
        </div>
        <Descriptions size="small" column={1} bordered>
          <Descriptions.Item label="Order Id">#{o.productionOrderId}</Descriptions.Item>
          <Descriptions.Item label="Product">{o.product || '-'}</Descriptions.Item>
          <Descriptions.Item label="Quantity">{o.quantity != null ? o.quantity : '-'}</Descriptions.Item>
          <Descriptions.Item label="Unit">{o.unitOfMeasurement || '-'}</Descriptions.Item>
          <Descriptions.Item label="Priority">{o.priority || '-'}</Descriptions.Item>
          <Descriptions.Item label="Production Team">{o.productionTeam || '-'}</Descriptions.Item>
          <Descriptions.Item label="Created Date">{fmt(o.createdDate)}</Descriptions.Item>
          <Descriptions.Item label="Expected Completion">{fmt(o.expectedCompletionDate)}</Descriptions.Item>
          <Descriptions.Item label="Remarks">{o.remarks || '-'}</Descriptions.Item>
        </Descriptions>
      </div>
    )
  }

  fetchProducts = () => {
    const pickList = (res) =>
      !res ? [] : Array.isArray(res) ? res : res.data || res.products || []
    Request.getStockProductMaster({ results: 2000 }).then((res) => {
      this.setState({ products: pickList(res) })
    })
  }

  fetchMedia = () => {
    const { group } = this.props
    const orderId = group && (group.orderId || group.key)
    if (!orderId) return
    this.setState({ loading: true })
    Request.productionOrderMedia({ orderId, _t: Date.now() }).then(
      ({ error, data }) => {
        if (!error) {
          const { photos, videos } = parseMedia(data)
          this.setState({ loading: false, items: [...photos, ...videos] })
        } else {
          this.setState({ loading: false })
          notification.error({ message: 'Failed to load media' })
        }
      }
    )
  }

  // Per-card review: Approve (Completed) / Reject (with a reason)
  reviewItem = async (item, status, remarks) => {
    if (!item || !item._id) {
      notification.error({ message: 'Missing media id' })
      return
    }
    const res =
      status === 'Rejected'
        ? await Request.rejectProductionMedia({ mediaId: item._id, remarks: remarks || '' })
        : await Request.completeProductionMedia({ mediaId: item._id })
    if (res && !res.error) {
      notification.success({
        message: status === 'Rejected' ? 'Media rejected' : 'Media approved',
      })
      this.dirty = true
      this.setState({ rejectingId: null, rejectText: '' })
      this.fetchMedia()
    } else {
      notification.error({ message: (res && res.message) || 'Failed to update media' })
    }
  }

  // delete an unwanted media item
  deleteMedia = async (item) => {
    if (!item || !item._id) return
    const res = await Request.deleteProductionMedia({ mediaId: item._id })
    if (res && !res.error) {
      notification.success({ message: 'Media deleted' })
      this.dirty = true
      this.setState((s) => ({
        items: s.items.filter((m) => String(m._id) !== String(item._id)),
      }))
    } else {
      notification.error({ message: (res && res.message) || 'Failed to delete media' })
    }
  }

  // Open the dedicated "Deleted Production Images" page for this order in a new
  // tab (a full page handles large numbers of images and the restore confirm
  // far better than a nested modal).
  openDeletedPage = () => {
    const { group } = this.props
    const orderId = group && (group.orderId || group.key)
    const qs = orderId && orderId !== 'unassigned' ? `?orderId=${encodeURIComponent(orderId)}` : ''
    window.open(`/productionOrders/deleted${qs}`, '_blank')
  }

  // reject-reason flow for the board cards
  startReject = (item) => this.setState({ rejectingId: item._id, rejectText: '' })
  cancelReject = () => this.setState({ rejectingId: null, rejectText: '' })
  confirmReject = (item) => {
    const remarks = (this.state.rejectText || '').trim()
    if (!remarks) {
      notification.error({ message: 'Please enter a rejection reason' })
      return
    }
    this.reviewItem(item, 'Rejected', remarks)
  }


  // Two read-only sections (no drag/drop). "Production As On" holds everything
  // not yet completed/stocked; "Completed" holds approved media and carries the
  // per-card "Move To Stock" action. Stocked media is hidden from both.
  // Each section is full-width with a responsive grid so it scales as the
  // number of images grows (cards wrap into rows instead of one tall column).
  // media items that actually have a file (skips empty placeholder records,
  // e.g. the production-order-form mirror rows that have no image)
  getMediaItems = () => this.state.items.filter((m) => m && m.url)

  renderSections = () => {
    const items = this.getMediaItems()
    // media is "completed" when its subcategory is 'completion' (upload value)
    // or 'completed' (set when a card was moved via the old board)
    const COMPLETED_SUBS = ['completion', 'completed']
    const completed = items.filter((i) => COMPLETED_SUBS.indexOf(i.subCategory) !== -1)
    const onProduction = items.filter(
      (i) => COMPLETED_SUBS.indexOf(i.subCategory) === -1 && i.subCategory !== STOCK_LANE
    )
    const sections = [
      { key: 'production_as_on', title: 'Production As On', list: onProduction, stock: false, accent: '#fa8c16' },
      { key: 'completed', title: 'Completed', list: completed, stock: true, accent: '#52c41a' },
    ]
    return (
      <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
        {sections.map((sec) => (
          <div
            key={sec.key}
            style={{
              flex: 1,
              minWidth: 0,
              background: '#fff',
              borderRadius: 10,
              padding: '14px 16px 16px',
              boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                paddingBottom: 14,
                marginBottom: 14,
                borderBottom: '1px solid #f0f0f0',
              }}
            >
              <span style={{ width: 4, height: 18, borderRadius: 2, background: sec.accent }} />
              <span style={{ fontWeight: 600, fontSize: 16 }}>{sec.title}</span>
              <Tag color={sec.accent} style={{ borderRadius: 10, marginLeft: 2 }}>
                {sec.list.length}
              </Tag>
            </div>

            {/* each column scrolls on its own so a long stage never pushes the
                other one down — both stages stay side by side and visible */}
            <div style={{ maxHeight: 'calc(100vh - 210px)', overflowY: 'auto', paddingRight: 4 }}>
              {sec.list.length ? (
                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
                    gap: 12,
                  }}
                >
                  {sec.list.map((item) => (
                    <MediaCard
                      key={item._id}
                      metadata={{
                        ...item,
                        onPreview: () => this.openPreview(item),
                        onComplete: () => this.reviewItem(item, 'Completed'),
                        onReject: () => this.startReject(item),
                        isRejecting: this.state.rejectingId === item._id,
                        rejectText: this.state.rejectText,
                        onRejectText: (v) => this.setState({ rejectText: v }),
                        onConfirmReject: () => this.confirmReject(item),
                        onCancelReject: this.cancelReject,
                        onDelete: () => this.deleteMedia(item),
                        onMoveToStock: sec.stock ? () => this.openStock(item) : null,
                      }}
                    />
                  ))}
                </div>
              ) : (
                <div
                  style={{
                    color: '#bbb',
                    textAlign: 'center',
                    padding: '28px 0',
                    border: '1px dashed #e8e8e8',
                    borderRadius: 8,
                  }}
                >
                  No media in this stage
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    )
  }

  // ---- Media preview (handled by the shared MediaViewer lightbox) ----
  openPreview = (item) => {
    const idx = this.getMediaItems().findIndex(
      (m) => String(m._id) === String(item._id)
    )
    this.setState({ previewIndex: idx >= 0 ? idx : 0 })
  }

  closePreview = () => {
    this.setState({ previewIndex: -1 })
  }

  // review action invoked from the MediaViewer's Approve/Reject controls;
  // updates local items so the viewer stays open and the board reflects it
  handleViewerReview = async (item, status) => {
    if (!item || !item._id) {
      notification.error({ message: 'Missing media id' })
      throw new Error('missing media id')
    }
    const res =
      status === 'Rejected'
        ? await Request.rejectProductionMedia({ mediaId: item._id })
        : await Request.completeProductionMedia({ mediaId: item._id })
    if (res && !res.error) {
      notification.success({
        message: status === 'Rejected' ? 'Media rejected' : 'Media approved',
      })
      this.dirty = true
      this.setState((s) => ({
        items: s.items.map((m) =>
          String(m._id) === String(item._id) ? { ...m, status } : m
        ),
      }))
      return status
    }
    notification.error({ message: (res && res.message) || 'Failed to update media' })
    throw new Error('review failed')
  }

  // ---- Move To Stock (popup reused from the review flow) ----
  openStock = (item) => {
    if (!this.state.products.length) this.fetchProducts()
    this.setState({
      stockModal: {
        ...emptyStockModal,
        visible: true,
        mediaId: item._id,
        itemOrderId: item.orderId || '',
        itemUser: item.userName || '',
        itemSubCategory: item.subCategory || '',
        itemType: item.type || '',
      },
    })
  }

  closeStock = () => {
    this.setState({ stockModal: { ...emptyStockModal } })
  }

  setStockField = (patch) => {
    this.setState((s) => ({ stockModal: { ...s.stockModal, ...patch } }))
  }

  selectStockProduct = (productId) => {
    const product = this.state.products.find((p) => p._id === productId)
    this.setStockField({
      productId,
      productName: product ? product.name : '',
      unit: product ? product.unit || '' : '',
    })
  }

  saveStock = async () => {
    const {
      mediaId,
      productId,
      productName,
      quantity,
      unit,
      description,
      remarks,
    } = this.state.stockModal
    if (!productId) {
      notification.error({ message: 'Please select a product' })
      return
    }
    if (!quantity || Number(quantity) <= 0) {
      notification.error({ message: 'Please enter a valid quantity' })
      return
    }
    this.setStockField({ saving: true })
    // 1. Create the real stock-movement entry (same master action as review)
    const res = await Request.addInward({
      recordDate: moment().toISOString(),
      type: 'Inward',
      totalData: [
        { productId, product: productName, quantity, description: description || '' },
      ],
    })
    if (res && !res.error) {
      // 2. Move the card into the Move-To-Stock lane and log it on the board
      await Request.moveMediaCategory({
        mediaId,
        subCategory: STOCK_LANE,
        remarks:
          remarks ||
          `Moved to stock: ${productName} × ${quantity}${unit ? ' ' + unit : ''}`,
      })
      notification.success({ message: res.message || 'Moved to stock' })
      this.setState({ stockModal: { ...emptyStockModal } })
      this.dirty = true
      this.fetchMedia()
    } else {
      notification.error({ message: (res && res.message) || 'Failed to move to stock' })
      this.setStockField({ saving: false })
    }
  }

  handleClose = () => {
    const { onUpdated, onClose } = this.props
    if (this.dirty && onUpdated) onUpdated()
    this.dirty = false
    if (onClose) onClose()
  }

  renderStockModal = () => {
    const { products, stockModal } = this.state
    const {
      visible,
      productId,
      quantity,
      saving,
      itemOrderId,
      itemUser,
      itemSubCategory,
      itemType,
      description,
      remarks,
    } = stockModal
    return (
      <Modal
        title="Move To Stock"
        visible={visible}
        onCancel={this.closeStock}
        onOk={this.saveStock}
        confirmLoading={saving}
        okText="Save to Stock"
        destroyOnClose
        zIndex={1200}
      >
        <p style={{ color: '#888', marginBottom: 12 }}>
          Add this approved {itemType || 'item'} into stock inventory. Select the
          matching product and enter the received quantity.
        </p>

        <Descriptions size="small" column={1} bordered className={styles.stockDetails}>
          {itemOrderId ? (
            <Descriptions.Item label="Order ID">#{itemOrderId}</Descriptions.Item>
          ) : null}
          {itemUser ? (
            <Descriptions.Item label="Uploaded By">{itemUser}</Descriptions.Item>
          ) : null}
          {itemSubCategory ? (
            <Descriptions.Item label="Subcategory">{itemSubCategory}</Descriptions.Item>
          ) : null}
          <Descriptions.Item label="Media Type">{itemType || '-'}</Descriptions.Item>
        </Descriptions>

        <Form layout="vertical" style={{ marginTop: 14 }}>
          <Form.Item label="Product" required>
            <Select
              showSearch
              allowClear
              placeholder="Select product"
              value={productId}
              optionFilterProp="children"
              style={{ width: '100%' }}
              dropdownStyle={{ zIndex: 1300 }}
              getPopupContainer={(trigger) => trigger.parentNode}
              onChange={this.selectStockProduct}
            >
              {products.map((p) => (
                <Option key={p._id} value={p._id}>
                  {p.name}
                  {p.productCode ? ` (${p.productCode})` : ''}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Quantity" required>
            <InputNumber
              min={1}
              placeholder="Quantity"
              value={quantity}
              style={{ width: '100%' }}
              onChange={(v) => this.setStockField({ quantity: v })}
            />
          </Form.Item>
          <Form.Item label="Description">
            <TextArea
              rows={2}
              placeholder="Description (saved on the stock ledger entry)"
              value={description}
              onChange={(e) => this.setStockField({ description: e.target.value })}
            />
          </Form.Item>
          <Form.Item label="Remarks">
            <TextArea
              rows={2}
              placeholder="Optional note"
              value={remarks}
              onChange={(e) => this.setStockField({ remarks: e.target.value })}
            />
          </Form.Item>
        </Form>
      </Modal>
    )
  }


  render() {
    const { visible, group } = this.props
    const { loading } = this.state
    if (!group) return null
    return (
      <Modal
        visible={visible}
        onCancel={this.handleClose}
        footer={null}
        width={'100%'}
        style={{ top: 0, maxWidth: '100%', margin: 0, paddingBottom: 0 }}
        bodyStyle={{
          height: 'calc(100vh - 55px)',
          overflowY: 'auto',
          padding: '16px 24px',
          background: '#f5f6f8',
        }}
        wrapClassName={styles.fullModalWrap}
        title={
          <span>
            Production Board — {group.label}{' '}
            <Tag color="blue" style={{ marginLeft: 8 }}>
              {group.mediaCount || 0} Media
            </Tag>
          </span>
        }
        destroyOnClose
      >
        {loading ? (
          <div className={styles.mediaLoading}>
            <Spin tip="Loading media..." />
          </div>
        ) : (
          this.renderSections()
        )}

        <div className={styles.modalFooter} style={{ textAlign: 'center' }}>
          <Button icon="delete" onClick={this.openDeletedPage} style={{ marginRight: 8 }}>
            Deleted Images
          </Button>
          <Button onClick={this.handleClose}>Close</Button>
        </div>

        <MediaViewer
          lightboxOnly
          reviewable
          completeLabel="Approve"
          statusLabels={{ Completed: 'Approved' }}
          hideControlsWhenReviewed
          items={this.getMediaItems()}
          openIndex={this.state.previewIndex}
          onClose={this.closePreview}
          onReview={this.handleViewerReview}
          onDelete={this.deleteMedia}
          detailsPanel={this.renderOrderDetailsPanel()}
        />
        {this.renderStockModal()}
      </Modal>
    )
  }
}

export default BoardModal2
